import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { USER_AUTHENTICATION_SERVICE, UserAuthInterface } from '../services/user-auth.interface';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private readonly router: Router, @Inject(USER_AUTHENTICATION_SERVICE) private readonly auth: UserAuthInterface) {}
  canActivate(): boolean | UrlTree {
    return this.auth.authenticatedUser?.token ? true : this.router.createUrlTree(['/account/login']);
  }
}
